import React, { useState } from 'react'
import { Button, Col, FloatingLabel, Form, Modal, Row } from 'react-bootstrap'
import { deleteAppointment } from '../../../../Adaptor/TUBSIS/controllers/Appointments/Appointments'
import moment from 'moment'
import { GetAppointmentGroupDetailsOutput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/getAppointmentModels'
import AppointmentCreate from './AppointmentCreate'
import PatientDetail from '../../patients/components/PatientDetail'
import { useNavigate } from 'react-router-dom'

type Props = {appointmentDetail: GetAppointmentGroupDetailsOutput}

const AppointmentDetail : React.FC<Props> = ({ appointmentDetail }) => {
  
    const [showModal, setShowModal] = useState(false);

    const openModal = () => {        
        //console.log("detail", appointmentDetail)
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const handleDeleteClick = (appointmentId: number) => {
        // Silme işlemine başlamadan önce kullanıcıyı uyaralım
        const isConfirmed: boolean = window.confirm("Randevuyu silmek istiyor musunuz?");
    
        // Eğer kullanıcı silmeyi onaylarsa devam edelim
        if (isConfirmed) {
            // Silme işlemini gerçekleştir
            deleteAppointment(appointmentId)
            .then((response) => {
              ////debugger
              //console.log("delete",response.data)
    
              window.location.reload();
              closeModal();
            })
            .catch((error) => {
              ////debugger
              console.log(error)
            })
        }
    };

    const navigate = useNavigate();

    const handleButtonClick = (userId: number) => {
        // Yönlendirme yapmak için navigate fonksiyonu kullanılır
        // console.log("Bir sıkıntı yok")
        navigate(`/patient/details/${userId}`);
    };

    return (
        <>
            <div className="w-100 btn btn-darken p-4" style={{backgroundColor:"#FFCDD2"}} onClick={() => openModal()}>
                <div className='d-flex justify-content-center item-align-center fw-bold w-100'>
                    {appointmentDetail.appointmentStartHour < 10 ? ("0" + appointmentDetail.appointmentStartHour.toString()) : appointmentDetail.appointmentStartHour}
                    :
                    {appointmentDetail.appointmentStartMunite < 10 ? ("0" + appointmentDetail.appointmentStartMunite.toString()) : appointmentDetail.appointmentStartMunite} (DOLU)
                </div>
                <div className="text-gray-700 fw-bold fs-7 pt-1">{appointmentDetail.isFirstAppointment ? "İLK RANDEVU" : "KONTROL"}</div>
            </div>
            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Randevu Bilgileri</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-column w-100 mb-3 me-2 justify-content-center align-items-center">
                        <div className="d-flex flex-stack">
                            <h5> 
                                {appointmentDetail.isFirstAppointment ? 
                                <span className="badge badge-primary" style={{fontSize:"1.5rem"}}>YENİ RANDEVU</span> : 
                                <span className="badge badge-primary" style={{fontSize:"1.5rem"}}>KONTROL RANDEVUSU</span>
                                }
                            </h5>
                        </div>
                    </div>

                    <FloatingLabel className='mb-3' controlId="patientId" key={1} label="Danışan">
                        <Form.Control name="patientId" value={appointmentDetail.patientFullName}>
                        </Form.Control>
                    </FloatingLabel>

                    <FloatingLabel className='mb-3' controlId="phoneNumber" key={2} label="Telefon Numarası">
                        <Form.Control name="phoneNumber" value={appointmentDetail.patientPhoneNumber}>
                        </Form.Control>
                    </FloatingLabel>

                    <Row className="mb-3">
                        <Form.Group as={Col}>
                            <FloatingLabel controlId="appointmentStartDate" label="Randevu Başlangıç Tarihi">
                                <Form.Control name="appointmentStartDate" value={moment(appointmentDetail.appointmentStartDate).format('DD MMMM YYYY HH:mm')}>
                                </Form.Control>
                            </FloatingLabel>
                        </Form.Group>

                        <Form.Group as={Col}>
                            <FloatingLabel controlId="appointmentEndDate" label="Randevu Bitiş Tarihi">
                                <Form.Control name="appointmentEndDate" value={moment(appointmentDetail.appointmentEndDate).format('DD MMMM YYYY HH:mm')}>
                                </Form.Control>
                            </FloatingLabel>
                        </Form.Group>
                    </Row>
                    
                </Modal.Body>
                <Modal.Footer>
                    
                    {appointmentDetail.appointmentId && appointmentDetail.appointmentId > 0 ? 
                    (
                        <Button variant="warning" onClick={() => handleButtonClick(appointmentDetail.patientId)}>
                            Danışan Bilgileri
                        </Button>
                    ) : 
                        <>  
                        </>
                    }

                    <Button variant="secondary" onClick={closeModal}>
                        Kapat
                    </Button>

                    {appointmentDetail.appointmentId && appointmentDetail.appointmentId > 0 ? 
                    (
                        <Button variant="danger" onClick={() => handleDeleteClick(appointmentDetail.appointmentId)}>
                            Sil
                        </Button>
                    ) : 
                        <Button variant="warning">
                            RANDEVU DETAYI BULUNAMADI.
                        </Button>
                    }
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default (AppointmentDetail)